__turbopack_context__.v({
  "filter": "FilterItem-module-sass-module__n0GydW__filter",
  "image": "FilterItem-module-sass-module__n0GydW__image",
  "imageElem": "FilterItem-module-sass-module__n0GydW__imageElem",
  "imageWrapper": "FilterItem-module-sass-module__n0GydW__imageWrapper",
  "title": "FilterItem-module-sass-module__n0GydW__title",
});
